import { ValidatorFn } from '@angular/forms';

export function genericVariableValidator(
  validatorName: string,
  firstValue: boolean | string | number,
  secondValue?: boolean | string | number
): ValidatorFn {
  return (): { [key: string]: true | null } => (firstValue || secondValue ? null : { [validatorName]: true });
}
